module.exports = __webpack_public_path__ + "asset/image-logo-866dec50a3451089.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/component/logo/image/logo.svg
// module id = gTjh
// module chunks = 3